// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__24VJF","consentsList":"PatientConsents_consentsList__f4J-d","consentsListEmpty":"PatientConsents_consentsListEmpty__1Vdy9"};